import { render, staticRenderFns } from "./CDialog.vue?vue&type=template&id=62401edd&scoped=true"
import script from "./CDialog.vue?vue&type=script&lang=js"
export * from "./CDialog.vue?vue&type=script&lang=js"
import style0 from "./CDialog.vue?vue&type=style&index=0&id=62401edd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62401edd",
  null
  
)

export default component.exports